<template>
  <table class="plan-table" border="1">
    <tr>
      <th colspan="8">
        <a-space>
          <div>生产任务日期</div>
          {{ selectTime.product }}
        </a-space>
      </th>
    </tr>

    <tr>
      <th>半成品</th>
      <th>型号</th>
      <th>生产任务</th>
      <th>当前完成数量</th>
      <th>当前送检数量</th>
      <th>当前合格数量</th>
      <!-- <th>当前完成率</th> -->
      <th>操作</th>
    </tr>

    <template v-for="(item, index) in productTasks" :key="item.id">
      <tr>
        <template v-if="index === 0">
          <td :rowspan="productTasks.length">
            {{ getProcessName(props.type) }}
          </td>
        </template>

        <td>{{ item.project }}</td>

        <td>
          <a-input-number :step="1" v-model:value="item.productionTaskNumber" disabled></a-input-number>
        </td>
        <!-- 当前完成数量 -->
        <td>
          <a-input-number :step="1" v-model:value="item.currentCompletedNumber"
            :disabled="productTasksDisabled"></a-input-number>
        </td>
        <!-- 当前送检数量 -->
        <td>
          <a-input-number :step="1" v-model:value="item.currentInspectionNumber" disabled></a-input-number>
        </td>
        <!-- 当前合格数量	 -->
        <td>
          <a-input-number :step="1" v-model:value="item.currentQualifiedNumber" disabled></a-input-number>
        </td>
        <!-- 当前完成率 -->
        <!-- <td v-if="item.currentCompletedRate">
          <div>
            {{ item.currentCompletedRate }} %
          </div>
        </td> -->

        <td>
          <a-button type="primary" size="small" @click="saveProductTasks(item)" :disabled="productTasksDisabled">保存
          </a-button>
        </td>
      </tr>
    </template>
  </table>

  <inventorysf :date="selectTime.product" :data="inventoryData" :type="props.type">
  </inventorysf>

  <!-- 
  <table class="plan-table" border="1">
    <tr>
      <th colspan="8">
        <a-space>
          <div>返修任务日期</div>
          {{ selectTime.repair }}
        </a-space>
      </th>
    </tr>

    <tr>
      <th>半成品</th>
      <th>型号</th>
      <th>返修任务</th>
      <th>当前完成数量</th>
      <th>当前送检数量</th>
      <th>当前合格数量</th>
      <th>当前完成率</th>
      <th>操作</th>
    </tr>

    <template v-for="(item, index) in repairTasks" :key="item.id">
      <tr>
        <template v-if="index === 0">
          <td :rowspan="repairTasks.length">{{ props.type }}</td>
        </template>

        <td>{{ item.name }}</td>

        <td>
          <a-input-number
            :step="1"
            v-model:value="item.productionTaskNumber"
          ></a-input-number>
        </td>
        <td>
          <a-input-number
            :step="1"
            v-model:value="item.currentCompletedNumber"
            :disabled="productTasksDisabled"
          ></a-input-number>
        </td>
        <td>
          <a-input-number
            :step="1"
            v-model:value="item.currentInspectionNumber"
            :disabled="productTasksDisabled"
          ></a-input-number>
        </td>
        <td>
          <a-input-number
            :step="1"
            v-model:value="item.currentQualifiedNumber"
            :disabled="productTasksDisabled"
          ></a-input-number>
        </td>
        <td>{{ item.currentCompletedRate }} %</td>

        <td>
          <a-button
            type="primary"
            @click="saveRepairTasks(item)"
            :disabled="repairTasksDisabled"
            size="small"
            >保存</a-button
          >
        </td>
      </tr>
    </template>
  </table> -->

  <!-- <table class="plan-table" border="1">
    <tr>
      <th rowspan="3"></th>
      <th colspan="6">
        {{ getProcessName(props.type) }}工序库存 {{ selectTime.repair }}
      </th>
    </tr>

    <tr>
      <th colspan="2">未检</th>
      <th colspan="2">合格</th>
      <th colspan="2">不合格</th>
    </tr>

    <tr>
      <th>swan 600</th>
      <th>swan 600P</th>
      <th>swan 600</th>
      <th>swan 600P</th>
      <th>swan 600</th>
      <th>swan 600P</th>
    </tr>

    <tr>
      <th>机身号</th>

      <template v-for="(item, key) in inventory" :key="key">
        <td class="series-number">
          <div v-for="subItem in item" :key="subItem.snNumber">
            {{ subItem.outputSnNumber || subItem.snNumber }}
          </div>
        </td>
      </template>
    </tr>

    <tr>
      <th>合计</th>

      <template v-for="(item, key) in inventory" :key="key">
        <td>
          {{ item.length === 0 ? "" : item.length }}
        </td>
      </template>
    </tr>
  </table> -->
</template>

<script>
import { computed, defineComponent, reactive, watch, inject, ref } from "vue";
import { timeStampToTime, debounce, Toast } from "@/utils/index";
import {
  getBatch,
  saveOrUpdateProductionTask,
  getProductionTaskList,
  getRepairTaskList,
  saveOrUpdateRepairTask,
} from "@/request/view/product";

import {
  updateProductionTask,
  getInventory,
} from "@/request/view/dailyProduction";

import inventorysf from "@/views/productDaily/components/product/components/inventorySF/index.vue";

import { useStore } from "vuex";

import {
  modelSpecificationsOption,
  getProcessName,
} from "@/views/productDaily/serve/option";

export default defineComponent({
  props: {
    editAuthority: Boolean,
    type: String,
    produceOrTpc: String,
  },
  components: {
    inventorysf,
  },
  setup(props) {
    const localDate = timeStampToTime("", "upload");

    const { id, username } = useStore().state.user.user;

    const selectTime = reactive({
      product: timeStampToTime("", "upload"),
      repair: timeStampToTime("", "upload"),
    });

    const productTasksDisabled = computed(() => {
      if (props.editAuthority) {
        return false;
      }
      return selectTime.product < localDate;
    });

    const repairTasksDisabled = computed(() => {
      if (props.editAuthority) {
        return false;
      }
      return selectTime.repair < localDate;
    });

    const getTasksItem = (type, project) => {
      return {
        // 批号
        batch: null,
        // 当前完成数量
        currentCompletedNumber: null,
        // 当前送检数量
        currentInspectionNumber: null,
        // 当前合格数量
        currentQualifiedNumber: null,
        // 当前完成率
        currentCompletedRate: null,
        id: null,
        // 库存未检数量
        inventoryNotInspectionNumber: null,
        // 生产模块or试产中心
        produceOrTpc: null,
        productionInstructionId: null,
        localDate: timeStampToTime("", "upload"),
        // 生产任务数量
        productionTaskNumber: null,
        project,
        // 库存合格数量
        qualifiedInventoryNumber: null,
        type,
        userId: id,
        username: username,
      };
    };

    const productTasks = reactive([]);

    const repairTasks = reactive([]);

    const inventoryData = ref(null);

    const inventory = reactive({
      swan600unChecked: [],
      swan600PunChecked: [],
      swan600qualified: [],
      swan600Pqualified: [],
      swan600unqualified: [],
      swan600Punqualified: [],
    });

    // 重置数据
    const setTasksData = () => {
      productTasks.length = 0;
      repairTasks.length = 0;

      modelSpecificationsOption.forEach((item) => {
        productTasks.push({
          name: item.value,
          data: getTasksItem(props.type, item.value),
        });

        repairTasks.push({
          name: item.value,
          data: getTasksItem(props.type, item.value),
        });
      });
    };

    // 获取当成完成率
    const getCurrentCompletedRate = (item) => {
      const taskNum = item.productionTaskNumber || item.repairTaskNumber;

      if (taskNum && item.currentQualifiedNumber) {
        item.currentCompletedRate = (
          (item.currentQualifiedNumber / taskNum) *
          100
        ).toFixed(2);
      }
    };

    // 获取生产任务数据
    const getProductTasks = () => {
      // setTasksData();
      productTasks.length = 0;
      getProductionTaskList({
        localDate: selectTime.product,
        type: props.type,
        produceOrTpc: props.produceOrTpc,
      }).then((res) => {
        if (res.code === 200 && res.message === "成功") {
          const tasksData = res.data[props.type];
          if (!tasksData) return;
          tasksData.forEach((item) => {

            productTasks.push(item);

            // console.log(productTasks, 'productTasks');
            // const [target] = productTasks.filter(
            //   (f) => item.project === String(f.name).replace(/\s/g, "")
            // );
            // Object.keys(item).forEach((key) => {
            //   target.data[key] = item[key];
            // });
            // getCurrentCompletedRate(target.data);
          });
        }
      });
    };

    const transformInventory = {
      未检: "unChecked",
      合格: "qualified",
      不合格: "unqualified",
    };

    // 获取库存信息
    const getInventoryByType = () => {
      // Object.keys(inventory).forEach((key) => {
      //   inventory[key].length = 0;
      // });
      inventoryData.value = null;
      getInventory({
        localDate: selectTime.product,
        type: props.type,
        produceOrTpc: props.produceOrTpc,
      }).then((res) => {
        if (!res.data || Object.keys(res.data).length === 0) return;
        inventoryData.value = res.data;
        // Object.keys(res.data).forEach((project) => {
        //   const projectData = res.data[project];
        //   Object.keys(projectData).forEach((key) => {
        //     const inventoryKey = `${project}${transformInventory[key]}`;
        //     if (inventoryKey && inventory[inventoryKey]) {
        //       inventory[inventoryKey].push(...projectData[key]);
        //     }
        //   });
        // });
      });
    };

    const getRepairTasks = () => {
      getRepairTaskList({
        localDate: selectTime.repair,
        type: "threeMajorItems",
      }).then((res) => {
        if (res.code === 200 && res.message === "成功") {
          Object.keys(res.data).forEach((key) => {
            const [swan600Item] = res.data[key].filter(
              (item) => item.project === "swan 600"
            );
            const [swan600PItem] = res.data[key].filter(
              (item) => item.project === "swan 600P"
            );

            Object.keys(repairTasks[key].swan600).forEach((fild) => {
              repairTasks[key].swan600[fild] = swan600Item[fild];
            });
            Object.keys(repairTasks[key].swan600P).forEach((fild) => {
              repairTasks[key].swan600P[fild] = swan600PItem[fild];
            });
          });
        }
      });
    };

    // 保存信息
    const saveProductTasks = debounce((data) => {
      if (!data.id) return;
      updateProductionTask(data).then((res) => {
        let type = res.code === 200 ? "success" : "warning";
        Toast(type, res.message, 3);
      });
    }, 200);

    const saveRepairTasks = debounce(() => {
      const data = [];
      Object.keys(repairTasks).forEach((key) => {
        data.push(repairTasks[key].swan600);
        data.push(repairTasks[key].swan600P);
      });

      saveOrUpdateRepairTask(data).then((res) => {
        let type = res.code === 200 ? "success" : "warning";
        Toast(type, res.message, 3);
        if (res.code === 200 && res.message === "成功") {
          res.data.forEach((item) => {
            const { type, project } = item;
            const machineType = project.replace(/\s+/g, "");
            repairTasks[type][machineType].id = item.id;
          });
        }
      });
    }, 200);

    const handleUpdateDateProduct = (e, stringTime) => {
      selectTime.product = stringTime;
      getProductTasks();
    };
    const handleUpdateDateRepair = (e, stringTime) => {
      selectTime.repair = stringTime;
      getRepairTasks();
    };

    const cascadeDate = inject("cascadeDate", null);

    const init = () => {
      getProductTasks();
      getInventoryByType();
      getRepairTasks();
    };

    init();

    watch(
      () => cascadeDate,
      (val) => {
        if (!val.value) return;
        const date = val.value.format("YYYY-MM-DD");
        if (date !== selectTime.repair || date !== selectTime.product) {
          selectTime.product = date;
          selectTime.repair = date;

          getProductTasks();
          getRepairTasks();
          getInventoryByType();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      props,
      getProcessName,
      inventory,
      productTasks,
      timeStampToTime,
      saveProductTasks,
      repairTasks,
      saveRepairTasks,
      selectTime,
      inventoryData,
      localDate,
      getProductTasks,
      getRepairTasks,
      getRepairTaskList,
      handleUpdateDateRepair,
      handleUpdateDateProduct,
      getCurrentCompletedRate,
      productTasksDisabled,
      repairTasksDisabled,
    };
  },
});
</script>

<style lang="less" scoped>
.plan-table {
  margin: 30px auto;

  th,
  td {
    padding: 5px 10px;
    text-align: center;
  }

  th {
    font-size: 16px;
  }

  tr:nth-child(1),
  tr:nth-child(2) {
    background: #e6e6e6;
  }

  tr:nth-child(1)>th {
    font-size: 18px;
  }

  .series-number {
    padding: 0;

    div {
      padding: 5px 10px;
      text-align: center;
      border-bottom: 1px solid #ccc;
    }

    :last-child {
      border-bottom: none;
    }
  }
}

.tasks-title {
  width: 120px;
}
</style>
